module.exports = __webpack_public_path__ + "static/media/03A.0d471104.png";